/**
 * WebsiteFAQ — accordion FAQ section. Native <details> for zero-JS reliability + good a11y.
 */
import { ChevronDown } from 'lucide-react';

export default function WebsiteFAQ({ config }) {
  const faq = Array.isArray(config.faq) ? config.faq : [];
  if (!faq.length) return null;
  const primary = config.brand?.primary || '#0f4c81';

  return (
    <section id="faq" className="py-20 lg:py-24 bg-slate-50" data-testid="ws-faq">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="mb-10">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-2.5">FAQ</p>
          <h2 className="text-3xl lg:text-4xl font-black tracking-tight text-slate-900">
            Common questions.
          </h2>
        </div>
        <div className="space-y-3">
          {faq.map((item, idx) => (
            <details
              key={item.q}
              className="group rounded-xl border border-slate-200 bg-white px-5 py-4 open:shadow-md transition-all"
              data-testid={`ws-faq-${idx}`}
            >
              <summary className="cursor-pointer flex items-center justify-between gap-4 list-none">
                <span className="text-[15px] font-semibold text-slate-900">{item.q}</span>
                <ChevronDown
                  size={18}
                  className="shrink-0 text-slate-500 transition-transform group-open:rotate-180"
                  style={{ color: primary }}
                />
              </summary>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
